module.exports = __webpack_public_path__ + "static/media/DSCF0115.a7e622e7.jpg";